import { AssetModel } from "src/app/store/models/asset.model";

export const DEFAULT_SIZE = "40px";
export const DRAFT_COLOR = "#FDD100";
export const DROPPED_COLOR = "#BEBEBE";
export const COMPLETED_COLOR = "#94C12E";

export async function createCustomMarker(
  id: string,
  icon: string,
  asset: AssetModel,
  isCompleted: boolean,
  subAssetCount: number,
): Promise<{ mapMarker: HTMLDivElement; markerContainer: HTMLDivElement }> {
  const mapMarker = document.createElement("div");
  const markerImage = document.createElement("img");
  const markerStatus = document.createElement("div");
  const markerContainer = document.createElement("div");

  mapMarker.className = "mapMarker";
  mapMarker.setAttribute("id", id);
  const isUrl = icon.startsWith("http://") || icon.startsWith("https://");
  markerImage.src = isUrl ? icon : `../assets/${icon}`;

  // Default styles for the marker image
  markerImage.style.width = "100%";
  markerImage.style.height = "100%";
  markerImage.style.objectFit = "cover";

  mapMarker.appendChild(markerImage);
  markerContainer.appendChild(mapMarker);
  const isRejected =
    asset.assetStatus?.status.assetRejected ||
    asset.assetStatus?.status.assetDecommissionRejected ||
    asset.assetStatus?.status.assetDemolitionRejected
      ? true
      : false;
  const isApproved =
    !asset.assetStatus?.status.assetDecommissionedPending &&
    !asset.assetStatus?.status.assetDemolitionPending &&
    asset.assetStatus?.status.assetRegistered
      ? true
      : false;
  const isDecomissionDemolish =
    (asset.assetStatus?.status.assetRegistered &&
      asset.assetStatus?.status.assetDecommissionedPending) ||
    (asset.assetStatus?.status.assetRegistered &&
      asset.assetStatus?.status.assetDemolitionPending)
      ? true
      : false;

  if (!asset.id) {
    applyStylesForDroppedMarker(mapMarker, markerStatus);
  } else {
    applyStylesForCompletedMarker(mapMarker, isCompleted);
  }

  if (subAssetCount > 0) {
    const countBadge = document.createElement("div");
    countBadge.style.zIndex = "2";
    countBadge.style.top = "-10px";
    countBadge.style.right = "-10px";
    countBadge.style.width = "20px";
    countBadge.style.height = "20px";
    countBadge.style.display = "flex";
    countBadge.style.fontSize = "11px";
    countBadge.style.color = "#000000";
    countBadge.style.fontWeight = "bold";
    countBadge.style.borderRadius = "50%";
    countBadge.style.background = "#fff";
    countBadge.style.position = "absolute";
    countBadge.style.alignItems = "center";
    countBadge.style.justifyContent = "center";
    countBadge.textContent = `+${subAssetCount}`;
    countBadge.style.border = "2px solid #4F4F4F";
    mapMarker.appendChild(countBadge);
  }

  return { mapMarker, markerContainer };
}

function applyStylesForCompletedMarker(
  mapMarker: HTMLElement,
  isCompleted: boolean,
) {
  mapMarker.style.padding = "5px";
  mapMarker.style.borderRadius = "50%";
  mapMarker.style.width = DEFAULT_SIZE;
  mapMarker.style.position = "relative";
  mapMarker.style.height = DEFAULT_SIZE;
  mapMarker.style.border = isCompleted
    ? `2px solid ${COMPLETED_COLOR}`
    : `2px solid ${DRAFT_COLOR}`;
  mapMarker.style.backgroundColor = "#ffffff";
  mapMarker.style.color = isCompleted ? "#7B7B7B" : DRAFT_COLOR;

  if (!isCompleted) {
    addCompletedMarkerPseudoElement(DRAFT_COLOR, mapMarker);
  } else {
    addCompletedMarkerPseudoElement(COMPLETED_COLOR, mapMarker);
  }
}

function applyStylesForDroppedMarker(
  mapMarker: HTMLElement,
  markerStatus: HTMLElement,
) {
  markerStatus.style.top = "-20%";
  markerStatus.style.right = "10%";
  markerStatus.style.fontSize = "11px";
  markerStatus.style.borderRadius = "5%";
  markerStatus.style.textAlign = "center";
  markerStatus.className = "markerStatus";
  markerStatus.style.color = DROPPED_COLOR;
  markerStatus.style.position = "absolute";
  markerStatus.style.background = "#ffffff";
  markerStatus.style.border = `2px solid ${DROPPED_COLOR}`;
  mapMarker.appendChild(markerStatus);

  mapMarker.style.padding = "5px";
  mapMarker.style.borderRadius = "50%";
  mapMarker.style.width = DEFAULT_SIZE;
  mapMarker.style.color = DROPPED_COLOR;
  mapMarker.style.position = "relative";
  mapMarker.style.height = DEFAULT_SIZE;
  mapMarker.style.backgroundColor = "#ffffff";
  mapMarker.style.border = `2px solid ${DROPPED_COLOR}`;
  addCompletedMarkerPseudoElement(DROPPED_COLOR, mapMarker);
}

export async function applyStylesForCrossInMarker(mapMarker: HTMLElement) {
  // Check if a .markerCross already exists inside the marker
  const existingCross = mapMarker.querySelector(".markerCross");
  if (existingCross) {
    return;
  }

  const markerCross = document.createElement("div");
  markerCross.className = "markerCross";
  markerCross.style.cssText = `
    top: -10px;
    right: -10px;
    width: 20px;
    height: 20px;
    display: flex;
    position: absolute;
  `;

  const icon = document.createElement("img");
  icon.src = "../../../assets/settings/structural/cross.svg";
  icon.style.display = "block";
  icon.style.margin = "0 auto";

  markerCross.appendChild(icon);
  mapMarker.appendChild(markerCross);
}

function addCompletedMarkerPseudoElement(
  color: string,
  mapMarker: HTMLElement,
) {
  const markerAfter = document.createElement("div");
  markerAfter.style.width = "0";
  markerAfter.style.content = "";
  markerAfter.style.height = "0";
  markerAfter.style.left = "50%";
  markerAfter.style.top = "100%";
  markerAfter.className = "markerAfter";
  markerAfter.style.position = "absolute";
  markerAfter.style.transform = "translate(-50%, 0)";
  markerAfter.style.borderTop = `8px solid ${color}`;
  markerAfter.style.borderLeft = "5px solid transparent";
  markerAfter.style.borderRight = "5px solid transparent";
  mapMarker.appendChild(markerAfter);
}

// !! UPDATE MARKER UTILS !! //
export function applyDroppedMarkerStyles(mapMarker: HTMLElement) {
  mapMarker.style.padding = "5px";
  mapMarker.style.width = DEFAULT_SIZE;
  mapMarker.style.borderRadius = "50%";
  mapMarker.style.height = DEFAULT_SIZE;
  mapMarker.style.color = DROPPED_COLOR;
  mapMarker.style.position = "relative";
  mapMarker.style.backgroundColor = "#ffffff";
  mapMarker.style.border = `2px solid ${DROPPED_COLOR}`;
}

export function applyCompletedMarkerStyles(mapMarker: HTMLElement) {
  mapMarker.style.padding = "5px";
  mapMarker.style.width = DEFAULT_SIZE;
  mapMarker.style.borderRadius = "50%";
  mapMarker.style.height = DEFAULT_SIZE;
  mapMarker.style.position = "relative";
  mapMarker.style.color = COMPLETED_COLOR;
  mapMarker.style.backgroundColor = "#ffffff";
  mapMarker.style.border = `2px solid ${COMPLETED_COLOR}`;
}

export function applyRejectApproveMarkerStyle(
  mapMarker: HTMLElement,
  isRejected: boolean,
  isApproved: boolean,
  isDecomissionDemolish: boolean,
  isApprover: boolean,
  subAssetCount: number,
) {
  mapMarker.style.padding = "5px";
  mapMarker.style.width = DEFAULT_SIZE;
  mapMarker.style.borderRadius = "50%";
  mapMarker.style.height = DEFAULT_SIZE;
  mapMarker.style.position = "relative";
  mapMarker.style.color = COMPLETED_COLOR;
  mapMarker.style.backgroundColor = "#ffffff";
  mapMarker.style.border = `2px solid ${COMPLETED_COLOR}`;

  if (isApprover) {
    const markerStatus = document.createElement("div");
    if (isRejected || isApproved || isDecomissionDemolish) {
      markerStatus.style.top = "-10px";
      markerStatus.style.right = "50%";
      markerStatus.style.transform = "translateX(50%)";
      // markerStatus.style.width = "80%";
      markerStatus.className = "markerStatus";
      markerStatus.style.position = "absolute";

      markerStatus.innerHTML = "";
      const icon = document.createElement("img");
      icon.src = isRejected
        ? "../../../assets/site-icons/cross.svg"
        : isApproved
          ? "../../../assets/site-icons/approved.svg"
          : isDecomissionDemolish
            ? "../../../assets/site-icons/decomission.svg"
            : "";
      icon.style.display = "block";
      icon.style.margin = "0 auto";
      icon.style.width = "20px";
      icon.style.width = "20px";
      markerStatus.appendChild(icon);
      mapMarker.appendChild(markerStatus);
    }
  }

  // Remove existing badge if any
  const existingBadge = mapMarker.querySelector(".subAssetCountBadge");
  if (existingBadge) {
    existingBadge.remove();
  }

  // Add new badge if subAssets exist
  if (subAssetCount > 0) {
    const countBadge = document.createElement("div");
    countBadge.classList.add("subAssetCountBadge");
    countBadge.textContent = `+${subAssetCount}`;
    countBadge.style.zIndex = "2";
    countBadge.style.top = "-10px";
    countBadge.style.width = "20px";
    countBadge.style.right = "-10px";
    countBadge.style.height = "20px";
    countBadge.style.display = "flex";
    countBadge.style.color = "#000000";
    countBadge.style.fontSize = "12px";
    countBadge.style.background = "#fff";
    countBadge.style.fontWeight = "bold";
    countBadge.style.borderRadius = "50%";
    countBadge.style.position = "absolute";
    countBadge.style.alignItems = "center";
    countBadge.style.justifyContent = "center";
    countBadge.style.border = "2px solid #4F4F4F";
    mapMarker.appendChild(countBadge);
  }
}

export function applyDraftMarkerStyles(
  mapMarker: HTMLElement,
  subAssetsCount: number,
) {
  mapMarker.style.padding = "5px";
  mapMarker.style.color = DRAFT_COLOR;
  mapMarker.style.borderRadius = "50%";
  mapMarker.style.width = DEFAULT_SIZE;
  mapMarker.style.height = DEFAULT_SIZE;
  mapMarker.style.position = "relative";
  mapMarker.style.backgroundColor = "#ffffff";
  mapMarker.style.border = `2px solid ${DRAFT_COLOR}`;

  // Remove existing badge if any
  const existingBadge = mapMarker.querySelector(".subAssetCountBadge");
  if (existingBadge) {
    existingBadge.remove();
  }

  // Add new badge if subAssets exist
  if (subAssetsCount > 0) {
    const countBadge = document.createElement("div");
    countBadge.classList.add("subAssetCountBadge");
    countBadge.textContent = `+${subAssetsCount}`;
    countBadge.style.zIndex = "2";
    countBadge.style.top = "-10px";
    countBadge.style.width = "20px";
    countBadge.style.right = "-10px";
    countBadge.style.height = "20px";
    countBadge.style.display = "flex";
    countBadge.style.color = "#000000";
    countBadge.style.fontSize = "11px";
    countBadge.style.background = "#fff";
    countBadge.style.fontWeight = "bold";
    countBadge.style.borderRadius = "50%";
    countBadge.style.position = "absolute";
    countBadge.style.alignItems = "center";
    countBadge.style.justifyContent = "center";
    countBadge.style.border = "2px solid #4F4F4F";
    mapMarker.appendChild(countBadge);
  }
}

export function applyPseudoElementStyles(
  color: string,
  markerAfter: HTMLElement,
) {
  markerAfter.style.width = "0";
  markerAfter.style.left = "50%";
  markerAfter.style.top = "100%";
  markerAfter.style.height = "0";
  markerAfter.style.content = "";
  markerAfter.style.position = "absolute";
  markerAfter.style.transform = "translate(-50%, 0)";
  markerAfter.style.borderTop = `8px solid ${color}`;
  markerAfter.style.borderLeft = "5px solid transparent";
  markerAfter.style.borderRight = "5px solid transparent";
  markerAfter.className = "markerAfter";
}
// !! UPDATE MARKER UTILS !! //

// Helper to set parent marker styles
export function setParentMarkerStyles(
  parentMarker: HTMLElement,
  borderColor: string,
  backgroundColor: string,
) {
  parentMarker.style.border = `2px solid ${borderColor}`;
  parentMarker.style.backgroundColor = backgroundColor;
}

// Helper to set marker after styles
export function setMarkerAfterStyles(
  markerAfter: HTMLElement,
  borderColor: string,
) {
  markerAfter.style.width = "0";
  markerAfter.style.left = "50%";
  markerAfter.style.top = "100%";
  markerAfter.style.height = "0";
  markerAfter.style.content = "";
  markerAfter.style.position = "absolute";
  markerAfter.style.transform = "translate(-50%, 0)";
  markerAfter.style.borderTop = `8px solid ${borderColor}`;
  markerAfter.style.borderLeft = "5px solid transparent";
  markerAfter.style.borderRight = "5px solid transparent";
  markerAfter.className = "markerAfter";
}

// Helper to set marker status styles
export function setMarkerStatusStyles(
  status: HTMLElement,
  borderColor: string,
) {
  status.style.top = "-20%";
  status.style.right = "10%";
  // status.style.width = "80%";
  // status.textContent = "Draft";
  status.style.color = "#7B7B7B";
  status.style.fontSize = "11px";
  status.style.borderRadius = "5%";
  status.style.textAlign = "center";
  // status.style.padding = "3px 6px";
  status.style.position = "absolute";
  status.style.background = "#ffffff";
  status.style.border = `2px solid ${borderColor}`;
  status.className = "markerStatus";
}

// Helper to create or update count number
export function updateCountNumber(
  parentMarker: HTMLElement,
  countNumber: HTMLElement | null,
  assetCount: number,
) {
  if (countNumber) {
    countNumber.textContent = assetCount.toString();
  } else {
    const newCountNumber = document.createElement("div");
    newCountNumber.textContent = assetCount.toString();
    newCountNumber.className = "count-number";
    newCountNumber.style.width = "21px";
    newCountNumber.style.height = "21px";
    newCountNumber.style.position = "absolute";
    newCountNumber.style.top = "19px";
    newCountNumber.style.left = "53px";
    newCountNumber.style.backgroundColor = "#ffffff";
    newCountNumber.style.color = "#ff0000";
    newCountNumber.style.fontSize = "14px";
    newCountNumber.style.fontWeight = "bold";
    newCountNumber.style.borderRadius = "0%";
    newCountNumber.style.display = "flex";
    newCountNumber.style.alignItems = "center";
    newCountNumber.style.justifyContent = "center";
    newCountNumber.style.border = "2px solid #ff0000";
    parentMarker.appendChild(newCountNumber);
  }
}

// Calculate Polygon centroid
// export function calculatePolygonCentroid(
//   polygon: google.maps.Polygon,
// ): google.maps.LatLngLiteral {
//   const path = polygon.getPath();
//   let x = 0,
//     y = 0,
//     area = 0;

//   for (let i = 0; i < path.getLength(); i++) {
//     const p1 = path.getAt(i);
//     const p2 = path.getAt((i + 1) % path.getLength());

//     const xi = p1.lng(),
//       yi = p1.lat();
//     const xj = p2.lng(),
//       yj = p2.lat();

//     const crossProduct = xi * yj - xj * yi;
//     x += (xi + xj) * crossProduct;
//     y += (yi + yj) * crossProduct;
//     area += crossProduct;
//   }

//   area *= 0.5;
//   x /= 6 * area;
//   y /= 6 * area;

//   return { lat: y, lng: x };
// }
export function calculatePolygonCentroid(
  polygon: google.maps.Polygon,
): google.maps.LatLngLiteral | null {
  const path = polygon.getPath();
  if (!path || path.getLength() < 3) {
    return null; // Not a valid polygon
  }

  let x = 0,
    y = 0,
    area = 0;

  for (let i = 0; i < path.getLength(); i++) {
    const p1 = path.getAt(i);
    const p2 = path.getAt((i + 1) % path.getLength());

    const xi = p1.lng(),
      yi = p1.lat();
    const xj = p2.lng(),
      yj = p2.lat();

    const crossProduct = xi * yj - xj * yi;
    x += (xi + xj) * crossProduct;
    y += (yi + yj) * crossProduct;
    area += crossProduct;
  }

  area *= 0.5;

  if (area === 0) {
    // fallback: simple average of vertices
    let sumLat = 0,
      sumLng = 0;
    for (let i = 0; i < path.getLength(); i++) {
      sumLat += path.getAt(i).lat();
      sumLng += path.getAt(i).lng();
    }
    return {
      lat: sumLat / path.getLength(),
      lng: sumLng / path.getLength(),
    };
  }

  x /= 6 * area;
  y /= 6 * area;

  return { lat: y, lng: x };
}

// Convert LatLng to Pixel
export function getPixelFromLatLng(
  position: google.maps.LatLng,
  map: google.maps.Map,
): { x: number; y: number } {
  if (!map) {
    throw new Error("Map instance is not available.");
  }
  const projection = map.getProjection();
  const bounds = map.getBounds();

  if (!projection || !bounds) {
    throw new Error("Projection or bounds are not available.");
  }

  const topRight = projection.fromLatLngToPoint(bounds.getNorthEast()!);
  const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest()!);
  const scale = Math.pow(2, map.getZoom()!);
  const worldPoint = projection.fromLatLngToPoint(position);

  const x = Math.floor((worldPoint!.x - bottomLeft!.x) * scale);
  const y = Math.floor((worldPoint!.y - topRight!.y) * scale);

  return { x, y };
}

export function resetMarkerStyles(
  marker: HTMLElement,
  borderColor: string,
  backgroundColor: string,
): void {
  marker.style.border = `2px solid ${borderColor}`;
  marker.style.backgroundColor = backgroundColor;
}

export function resetMarkerAfterStyles(
  markerAfter: HTMLElement,
  borderColor: string,
): void {
  markerAfter.style.width = "0";
  markerAfter.style.left = "50%";
  markerAfter.style.top = "100%";
  markerAfter.style.height = "0";
  markerAfter.style.content = "";
  markerAfter.style.position = "absolute";
  markerAfter.style.transform = "translate(-50%, 0)";
  markerAfter.style.borderTop = `8px solid ${borderColor}`;
  markerAfter.style.borderLeft = "5px solid transparent";
  markerAfter.style.borderRight = "5px solid transparent";
  markerAfter.className = "markerAfter";
}

export function setMarkerStatus(status: HTMLElement, color: string): void {
  status.style.top = "-20%";
  status.style.right = "10%";
  status.style.width = "80%";
  status.style.color = color;
  status.style.fontSize = "11px";
  status.style.borderRadius = "5%";
  status.style.textAlign = "center";
  status.style.padding = "3px 6px";
  status.style.position = "absolute";
  status.style.background = "#ffffff";
  status.style.border = `2px solid ${color}`;
  status.className = "markerStatus";
}

export function removeElementIfExists(
  parent: HTMLElement,
  child: HTMLElement | null,
): void {
  if (child && parent.contains(child)) {
    parent.removeChild(child);
  }
}
